const Sharp = ({x, y, width, height}) => {
    return (
        <g stroke="#000000" strokeWidth={2}>
            {/*Left vertical line */}
            <line x1={x - width / 5} x2={x - width / 5} y1={y - height / 2} y2={y + height / 2}/>
            {/*Right vertical line */}
            <line x1={x + width / 5} x2={x + width / 5} y1={y - height / 2 - 2} y2={y + height / 2 - 2} />
            {/*Upper horizontal line */}
            <line x1={x - width / 2} x2={x + width / 2} y1={y - height / 5} y2={y - height / 5 - 2} />
            {/*Lower horizontal line */}
            <line x1={x - width / 2} x2={x + width / 2} y1={y + height / 5} y2={y + height / 5 - 2} />
        </g>
    )
}

export default Sharp